/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import { EnumDropdown } from 'framework/form';
import { OneStopRequestStatus } from 'domain/shared/oneStop';

const OneStopRequestStatusFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <EnumDropdown options={OneStopRequestStatus} {...props} />
    </DropDownFilter>
  );
};

export default OneStopRequestStatusFilter;
